const Newsletter = {
  parts: [
    'container',
    'heading',
    'subtitle',
    'inputContainer',
    'input',
    'submitButton',
    'submitButtonIcon',
    'errorText',
    'alert',
    'socialHeading',
    'recaptcha',
    'link'
  ],
  baseStyle: {
    container: {
      display: 'flex',
      width: 'full',
      py: {base: 8, md: 12},
      px: {base: 6, md: 12.5},
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: {base: 15, md: 30},
      background: 'blackAlpha.450',
      backdropFilter: 'blur(15px)',
      borderRadius: 'md',
      position: 'relative',
    },
    heading: {
      alignSelf: 'stretch',
      color: 'white',
      fontFamily: 'heading',
      fontSize: '2xl',
      fontStyle: 'normal',
      fontWeight: 'semibold',
      lineHeight: '140%',
    },
    subtitle: {
      alignSelf: 'stretch',
      color: 'whiteAlpha.800',
      fontFamily: 'body',
      fontSize: 'sm',
      fontStyle: 'normal',
      fontWeight: 'normal',
      lineHeight: '160%',
    },
    inputContainer: {
      display: 'flex',
      width: {base: 'full', md: '300px'},
      height: 15,
      py: 2.5,
      px: 0,
      alignItems: 'center',
      gap: 2.5,
      borderBottom: '1px solid',
      borderColor: 'whiteAlpha.900',
      position: 'relative',
    },
    input: {
      flex: '1 0 0',
      color: 'whiteAlpha.700',
      fontFamily: 'body',
      fontSize: 'sm',
      fontStyle: 'normal',
      fontWeight: 'normal',
      lineHeight: '160%',
      background: 'transparent',
      border: 'none',
      pl: 0,
      outline: 'none',
      _placeholder: {
        color: 'whiteAlpha.700',
      },
      _focus: {
        color: 'white',
        boxShadow: 'none',
      },
    },
    submitButton: {
      flexShrink: 0,
      color: 'white',
      minWidth: 'auto',
      padding: 0,
      _hover: {
        color: 'whiteAlpha.800',
        transform: 'translateX(2px)',
      },
      _active: {
        transform: 'translateX(1px)',
      },
      transition: 'all 0.2s ease-in-out',
    },
    submitButtonIcon: {
      width: 4,
      height: 4,
    },
    errorText: {
      color: 'red.300',
      fontSize: 'sm',
      fontWeight: 'normal',
    },
    alert: {
      background: 'whiteAlpha.250',
      border: '1px solid',
      borderColor: 'whiteAlpha.350',
      color: 'white',
      borderRadius: 'md',
      fontSize: 'sm',
    },
    socialHeading: {
      alignSelf: 'stretch',
      color: 'whiteAlpha.800',
      fontFamily: 'body',
      fontSize: 'md',
      fontStyle: 'normal',
      fontWeight: 'normal',
      lineHeight: '160%',
    },
    recaptcha: {
      color: 'white',
      fontFamily: 'body',
      fontSize: 'sm',
      fontStyle: 'normal',
      fontWeight: 'normal',
      lineHeight: '140%',
    },
    link: {
      color: 'white',
      textDecoration: 'underline',
      cursor: 'pointer',
      _hover: {
        textDecoration: 'none',
        color: 'whiteAlpha.800',
      },
    },
  },
};

export default Newsletter;
